// Badge "datos en vivo" con punto pulsante verde. Refuerza la confianza mostrando
// que la identidad/ficha del vehículo proviene EN VIVO del Registro Civil (SRCeI vía Boostr).
export const LiveDataBadge = ({
  className = "",
  label = "Datos en vivo · Registro Civil de Vehículos (SRCeI)",
}) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 text-[11px] font-semibold text-emerald-300 ${className}`}
    data-testid="live-data-badge"
  >
    <span className="relative flex h-2 w-2 shrink-0">
      <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
    </span>
    {label}
  </span>
);
